import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { BsFillTrash3Fill } from "react-icons/bs";

function DeleteCourseConfirmation({ onDeleteConfirm, course }: any) {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleDeleteClick = () => {
    setShowModal(true);
  };

  const handleConfirm = () => {
    onDeleteConfirm(course.user_id);
    setShowModal(false);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <BsFillTrash3Fill
        style={{ color: "darkred", cursor: "pointer" }}
        onClick={() => {
          handleDeleteClick();
        }}
        title={"Obriši grupu"}
      />

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potvrdi brisanje grupe</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Jeste li sigurni da želite obrisati grupu{" "}
          <strong>
            {course.first_name} {course.last_name}
          </strong>
          ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-primary" onClick={handleClose}>
            Odustani
          </Button>
          <Button onClick={handleConfirm}>Obriši</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeleteCourseConfirmation;
